import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable, Subject } from 'rxjs';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'autocompleteControl',
  templateUrl: './autocomplete-control.component.html',
  styleUrls: ['./autocomplete-control.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class AutocompleteControlComponent implements OnInit {

  @ViewChild('autoCompleteInput', { read: MatAutocompleteTrigger }) autoComplete: MatAutocompleteTrigger;
  @Output() selectedToParent = new EventEmitter<any>();
  @Input() formControlFieldName: string;
  @Input() type: string = 'search';
  @Input() placeholder: string = "Enter text to search";
  @Input() options: Observable<any[]>;
  @Input() mxLength: number = 100;
  @Input() displaySearchFor: string = 'default';
  @Input() multipleSearch: boolean = false;
  @Input() displayWithFunction: (value: any) => string = this.defaultDisplayWithFn;

  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  public addOnBlur = true;
  public chipLists: any[] = [];
  public formGroup: FormGroup;
  private _nextPage$ = new Subject();
  private _onDestroy = new Subject();

  constructor(private ctrlContainer: FormGroupDirective) { }

  ngOnInit(): void {
    this.chipLists = [];
    const control = new FormControl('');
    this.formGroup = this.ctrlContainer.form;
    this.formGroup.addControl(this.formControlFieldName, control);
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  add(event: MatChipInputEvent): void {
    event.chipInput!.clear();
  }

  remove(element: any): void {
    const index = this.chipLists.indexOf(element);
    if (index >= 0) {
      this.chipLists.splice(index, 1);
      this.selectedToParent.emit(this.chipLists);
    }
  }

  onScroll() {
    this._nextPage$.next();
  }

  sendToParent(selected: any) {
    if (this.displaySearchFor === 'NameMail') this.chipLists.push(selected);
    this.selectedToParent.emit(this.displaySearchFor === 'NameMail' ? this.chipLists : selected);
  }

  defaultDisplayWithFn(value: any) { return value ? value.name : ''; }

}